import React, { useState } from "react"
import * as uuid from "uuid"
import * as layouts from "layouts"
import * as inputs from "inputs"
import * as icons from "icons"
import * as md5x from "md5x"
import * as training from "brandguard/display/training"
import { DocumentKernelRulesEnabled } from "brandguard/brandguard.kernel_pb"

interface props extends layouts.containers.FlexProps {
	settings: DocumentKernelRulesEnabled
	onChange(upd: DocumentKernelRulesEnabled): void
}

export default function CustomRules(props: React.PropsWithChildren<props>): JSX.Element {
	const labelwidth = "12ch"
	const { settings, onChange, ...rest } = props
	const [description, setDescription] = useState("")
	const [rule, setRule] = useState("")
	const [reset, setReset] = useState(uuid.v4())

	const rules = (settings.rules || []).map((r) => (
		<layouts.Flex key={r.id} py="5px" flexDirection="column">
			<layouts.Flex>
				<layouts.Span>{r.description}</layouts.Span>
				<layouts.Span
					ml="auto"
					onClick={(evt) => {
						evt.stopPropagation()
						onChange({ ...settings, rules: settings.rules.filter((o) => o.id !== r.id) })
					}}
				>
					<icons.Trash width="14px" height="14px" />
				</layouts.Span>
			</layouts.Flex>
			<layouts.Span>{r.rule}</layouts.Span>
		</layouts.Flex>
	))

	return (
		<layouts.Flex flexDirection="column" flex="1" {...rest}>
			<layouts.forms.Container key={reset} p="10px">
				<layouts.forms.Group>
					<layouts.forms.Label width={labelwidth}>Description</layouts.forms.Label>
					<inputs.Text
						autoFocus
						placeholder="short description of the rule"
						onChange={(evt) => setDescription(evt.target.value)}
						className={training.layouts.styledTextInput}
					/>
				</layouts.forms.Group>
				<layouts.forms.Group>
					<layouts.forms.Label width={labelwidth}>Rule</layouts.forms.Label>
					<inputs.Text
						placeholder="explain the rule to enforce"
						onChange={(evt) => setRule(evt.target.value)}
						className={training.layouts.styledTextInput}
					/>
				</layouts.forms.Group>
				<layouts.Flex flex="1" flexDirection="row" justifyContent="space-between" mt="10px">
					<layouts.buttons.outline onClick={() => setReset(uuid.v4())} width="10ch" borderRadius="5px">
						Cancel
					</layouts.buttons.outline>
					<layouts.buttons.primary
						onClick={() => {
							onChange({
								...settings,
								rules: (settings.rules || []).concat({ id: md5x.string(rule), description: description, rule: rule }),
							})
							setReset(uuid.v4())
						}}
						borderRadius="5px"
						width="10ch"
					>
						Add
					</layouts.buttons.primary>
				</layouts.Flex>
			</layouts.forms.Container>
			<layouts.Flex flexDirection="column">{rules}</layouts.Flex>
		</layouts.Flex>
	)
}
